import { Slider } from "./ui/slider";
import { Label } from "./ui/label";
import { formatBucketEUR } from "../lib/taxonomy";

/**
 * Rango con slider sobre buckets pre-definidos.
 * `buckets`: array creciente de valores (ej. [0, 100k, 250k, 500k, 1M, ...]).
 * `value`: [minIdx, maxIdx] (índices dentro de `buckets`).
 * Si maxIdx === buckets.length - 1 se interpreta como "sin tope".
 */
export default function BucketRangeSlider({
  label,
  buckets,
  value,
  onChange,
  testPrefix,
  unit = "€",
}) {
  const lastIdx = buckets.length - 1;
  const [minIdx, maxIdx] = value;
  const minLabel = formatBucketEUR(buckets[minIdx]);
  const maxLabel = maxIdx === lastIdx ? `${formatBucketEUR(buckets[lastIdx])}+` : formatBucketEUR(buckets[maxIdx]);
  return (
    <div className="space-y-3" data-testid={`${testPrefix}-section`}>
      <div className="flex items-baseline justify-between">
        <Label className="font-mono-label text-muted-foreground">{label}</Label>
        <span className="font-serif-display text-lg" data-testid={`${testPrefix}-display`}>
          {minLabel} <span className="text-muted-foreground">—</span> {maxLabel}
        </span>
      </div>
      <Slider
        min={0}
        max={lastIdx}
        step={1}
        value={value}
        onValueChange={onChange}
        data-testid={`${testPrefix}-slider`}
      />
      <div className="flex justify-between font-mono-label text-muted-foreground" style={{ fontSize: "0.55rem" }}>
        <span>{formatBucketEUR(buckets[0])}</span>
        <span>{formatBucketEUR(buckets[lastIdx])}+</span>
      </div>
      <span className="sr-only">{unit}</span>
    </div>
  );
}
